/**
 * The generated blank's server state (docs/ux/matter-hub.md, the Report
 * tab): the head, the registry's word on generating, and Generate as a 202
 * job polled until it lands.
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiError, api, reasonOf } from '@/app/api';
import type { ReportView } from '@/app/types';
import { auditKey } from '../useMatter';

export const reportKey = (ref: string) => ['matters', ref, 'report'] as const;

export function useReport(ref: string) {
  return useQuery({
    queryKey: reportKey(ref),
    queryFn: () => api<ReportView>(`/api/matters/${encodeURIComponent(ref)}/report`),
    retry: (count) => count < 1,
    refetchInterval: (query) => (query.state.data?.head?.build?.state === 'running' || query.state.data?.head?.build?.state === 'queued' ? 1500 : false),
  });
}

export function useGenerateBlank(ref: string) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: () => api<{ jobId: string; state: string }>(`/api/matters/${encodeURIComponent(ref)}/report/generate`, { method: 'POST' }),
    onSettled: () => { void client.invalidateQueries({ queryKey: reportKey(ref) }); void client.invalidateQueries({ queryKey: auditKey(ref) }); },
  });
}

/** The refusal's sentence, or a plain one. */
export function generateRefusal(err: unknown): string {
  if (err instanceof ApiError && err.status === 409) return reasonOf(err) ?? 'A blank is being generated; wait for it.';
  if (err instanceof ApiError && err.status === 422) return reasonOf(err) ?? 'Generation was refused.';
  return 'Could not start the blank. Nothing changed. Try again.';
}
